import React, { useState } from "react";
import "../FormA/FormA.css";

const FormD = ({ header, statuss }) => {
  const [isChecked, setIsChecked] = useState({
    Yes: true,
    No: false,
  });

  const [isCheck, setIsCheck] = useState({
    Yes: true,
    No: false,
  });

  const handleCheckboxChange = (event) => {
    const { name } = event.target;
    if (name === "Yes") {
      setIsChecked({
        Yes: true,
        No: false,
      });
    } else if (name === "No") {
      setIsChecked({
        Yes: false,
        No: true,
      });
    }
  };

  const handleCheckChange = (event) =>{
    const { name } = event.target;
    if (name === "Yes") {
      setIsCheck({
        Yes: true,
        No: false,
      });
    } else if (name === "No") {
      setIsCheck({
        Yes: false,
        No: true,
      });
    }
  }

  return (
    <div className="w-full flex flex-col gap-5">
      <div className="text-[15px]">
        I confirm that I have read the Performance Evaluation and Development
        Plan, Part A – C.
      </div>

      <div className="flex flex-col w-full justify-center">
        <div className="text-[15px] bg-[#ccc] py-2 px-1">
          This section is for any comments the appraisee may wish to make.
        </div>

        <div className="text-[15px] bg-[#ccc] py-2 px-1 w-full section_d_comment">
          Comments
        </div>

        <textarea
          name="CriticalExperience"
          // onChange={handleChange}
          type="text"
          className="w-full outline-none p-2 min-h-[120px] bg-[#fff]"
          placeholder="Type Comment Here..."
          // value={items.task}
        />
      </div>

      <div className="w-full flex flex-col">
        <div className="w-full section_d_comment flex items-center">
          <div className="bg-[#ccc] w-full p-2 text-[15px]">
            I agree with the line manager’s evaluation rating as described in
            Parts A & B
          </div>
          <div className="flex min-w-[150px] flex-col">
            <div className="w-full items-center flex gap-4">
              <p className="text-[14px] font-[600] w-[30px] px-2">YES</p>
              <input
                type="checkbox"
                name="Yes"
                checked={isChecked.Yes}
                onChange={handleCheckboxChange}
                className="form-checkbox h-5 w-5 text-blue-600"
              />
            </div>

            <div className="w-full items-center flex gap-4">
              <p className="text-[14px] font-[600] w-[30px] px-2">NO</p>
              <input
                type="checkbox"
                name="No"
                checked={isChecked.No}
                onChange={handleCheckboxChange}
                className="form-checkbox h-5 w-5 text-blue-600"
              />
            </div>
          </div>
        </div>

        <div className="flex flex-col w-full gap-1">
          <div className="comments_class w-full flex justify-start">
            <div className="p-2 py-4 bg-[#E7E6E6] w-[150px]">Name of Staff</div>
            <input className="w-full outline-none p-2 bg-[#fff] uppercase font-[500] text-[15px]" />
          </div>

          <div className="comments_class w-full flex justify-between flex-wrap gap-2 items-center">
            <div className="flex grow min-w-[250px]">
              <div className="p-2 py-4 bg-[#E7E6E6] w-[150px]">Signature</div>
              <input className="w-full outline-none p-2 bg-[#fff]" />
            </div>

            <div className="flex grow min-w-[250px]">
              <div className="p-2 py-4 bg-[#E7E6E6] w-[150px]">Date</div>
              <input
                className="w-full outline-none p-2 bg-[#fff]"
                placeholder="dd/mm/yyyy"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="flex flex-col w-full gap-2">
        <b>
          <p className="text-[15px]">Reviewing Committee</p>
        </b>

        <p className="text-[15px]">
          It is the reviewing committee’s responsibility to ensure that any
          comments they make are seen by the staff. The reviewing committee must
          also endorse the evaluation form:
        </p>

        <div className="w-full flex flex-col gap-3">
          <div className="w-full section_d_comment flex items-center">
            <div className="bg-[#ccc] w-full p-2 text-[15px]">
              I agree with the line manager’s evaluation rating as described in
              Parts A & B
            </div>
            <div className="flex min-w-[150px] flex-col">
              <div className="w-full items-center flex gap-4">
                <p className="text-[14px] font-[600] w-[30px] px-2">YES</p>
                <input
                  type="checkbox"
                  name="Yes"
                  checked={isCheck.Yes}
                  onChange={handleCheckChange}
                  className="form-checkbox h-5 w-5 text-blue-600"
                />
              </div>

              <div className="w-full items-center flex gap-4">
                <p className="text-[14px] font-[600] w-[30px] px-2">NO</p>
                <input
                  type="checkbox"
                  name="No"
                  checked={isCheck.No}
                  onChange={handleCheckChange}
                  className="form-checkbox h-5 w-5 text-blue-600"
                />
              </div>
            </div>
          </div>

          <div className="text-[15px] bg-[#ccc] py-2 px-1 w-full section_d_comment">
            Comments & Recommendation
          </div>

          <textarea
            name="CriticalExperience"
            // onChange={handleChange}
            type="text"
            className="w-full outline-none p-2 min-h-[120px] bg-[#fff]"
            placeholder="Type Comment Here..."
            // value={items.task}
          />

          <div className="flex flex-col w-full gap-1">
            <div className="comments_class w-full flex justify-start">
              <div className="p-2 py-4 bg-[#E7E6E6] w-[150px]">
                Reviewing Committee
              </div>
              <input className="w-full outline-none p-2 bg-[#fff]" />
            </div>

            <div className="comments_class w-full flex justify-between flex-wrap gap-2 items-center">
              <div className="flex grow min-w-[250px]">
                <div className="p-2 py-4 bg-[#E7E6E6] w-[150px]">Signature</div>
                <input className="w-full outline-none p-2 bg-[#fff]" />
              </div>

              <div className="flex grow min-w-[250px]">
                <div className="p-2 py-4 bg-[#E7E6E6] w-[150px]">Date</div>
                <input
                  className="w-full outline-none p-2 bg-[#fff]"
                  placeholder="dd/mm/yyyy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormD;
